import { ForgotPasswordWrapper } from "../../components";

export default function ForgotPasswordPage() {
  return (
    <div className="spacer-md">
      <ForgotPasswordWrapper />
    </div>
  );
}
